"use strict";

const _ = require('underscore');
const Backbone = require('dibs-backbone');
const endpoints = require('dibs-endpoints');
const Seller = require('bunsen/models/Seller');
const SoaModel = require('bunsen/models/SoaModel');
const User = require('bunsen/models/identity/User');

const Hold = SoaModel.extend();

_.extend(Hold.prototype, {
    url: function () {
        return endpoints.inventoryHoldById(this.get('id'));
    },
    relations: () => [
        {
            type: Backbone.One,
            key: 'buyer',
            relatedModel: User
        },
        {
            type: Backbone.One,
            key: 'item',
            // to avoid circular dependency
            relatedModel: require('bunsen/models/inventory/Item-v3')
        },
        {
            type: Backbone.One,
            key: 'seller',
            relatedModel: Seller
        }
    ],
    isActive: function () {
        return this.get('status') === 'ACTIVE';
    },
    getExpirationDate: function () {
        return this.get('expirationDate');
    },
    getConversationUrl: function () {
        const buyerId = this.get('buyer.id');
        const itemId = this.get('item.id');
        return buyerId && itemId
            ? ['/dealers/conversations/buyer', buyerId, 'item', itemId].join('/')
            : null;
    },
    release: function () {
        return this.set({
            status: 'DELETED',
            deletedReasonCode: 'CANCELLED'
        });
    }
});

_.extend(Hold, {
    statuses: {
        NEW: 'NEW',
        REQUESTED: 'REQUESTED',
        ACTIVE: 'ACTIVE',
        DELETED: 'DELETED'
    },
    deletedReasonCodes: {
        DECLINED: 'DECLINED',
        EXPIRED: 'EXPIRED',
        ITEM_SOLD: 'ITEM_SOLD',
        CANCELLED: 'CANCELLED',
        ITEM_DELETED: 'ITEM_DELETED'
    }
});

module.exports = Hold;



// WEBPACK FOOTER //
// ./~/bunsen/models/inventory/Hold.es.js